import { render, staticRenderFns } from "./RecommendCreate.vue?vue&type=template&id=af23be56&scoped=true&"
import script from "./RecommendCreate.vue?vue&type=script&lang=js&"
export * from "./RecommendCreate.vue?vue&type=script&lang=js&"
import style0 from "./RecommendCreate.vue?vue&type=style&index=0&id=af23be56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af23be56",
  null
  
)

export default component.exports